module.exports = __webpack_public_path__ + "img/hbjyk.a188db4d.png";